import { match as matchInteger } from './integer';

export const match = matchInteger;
